<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M26.602 4.058a1.859 1.859 0 00-.977.015L5.372 9.777a1.87 1.87 0 00-.284 3.5l9.255 4.38 4.38 9.255a1.87 1.87 0 003.5-.284v-.005l5.704-20.248a1.858 1.858 0 00-1.325-2.317zM6.241 11.611l19.696-5.548-5.548 19.697-4.09-8.645 4.408-4.408a1 1 0 00-1.414-1.414L14.885 15.7l-8.644-4.09z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsPaperPlaneTiltOutline'
}
</script>
